import WIDGETS from './widgets';

export default {
  name: 'user_tickets',
	sx: {
		height: '100%',
    flexWrap: 'nowrap'
	},
	spacing: 0,
	direction: 'column',
	widgets: [
		{ content: WIDGETS.USER_TICKETS, breakpoints: { xs: 12 }, lazy_loading: 0, sx: { flexGrow: 1 } },
	],
};
